import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';
import { ContactShape } from './Contact';

const Jurisdiction = {
  id: PropTypes.number,
  clientId: PropTypes.number,
  zoneId: PropTypes.string,
  geometry: MapGeometryShape,
  contacts: PropTypes.arrayOf(ContactShape),
};

export const JurisdictionShape = PropTypes.shape(Jurisdiction);
export const JurisdictionExact = PropTypes.exact(Jurisdiction);
